import React from 'react';
import { motion } from 'framer-motion';
import MeshSystemExplanation from './MeshSystemExplanation';
import MeshAnimation from './MeshAnimation';
import MeshVsRepeaters from './MeshVsRepeaters';

/**
 * MeshSystemContent component
 * Displays the mesh system content tab
 */
const MeshSystemContent = ({ contentVariants }) => {
  return (
    <motion.div
      key="mesh-content"
      className="p-4 md:p-8"
      variants={contentVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      {/* Mesh System Explanation */}
      <MeshSystemExplanation />
      
      {/* Mesh Animation */}
      <div className="max-w-7xl mx-auto mt-8">
        <MeshAnimation />
      </div>
      
      {/* Mesh vs Repeaters Comparison */}
      <div className="max-w-7xl mx-auto">
        <MeshVsRepeaters />
      </div>
    </motion.div>
  );
};

export default MeshSystemContent;